// import React from "react";
// import certifIcon from "../../assets/img/aboutUs/content.png";
// import surMesureIcon from "../../assets/img/aboutUs/mortarboard.png";
// import deviseIcon from "../../assets/img/aboutUs/skill-development.png";

// const Entreprise = () => {
//   return (
//     <section className="entreprise-section" id="entreprise">
//       <div>
//         <h1>
//           FORMATIONS <span>SUR MESURE</span> POUR LES ENTREPRISES
//         </h1>
//         <p>
//           Chez UP4MIND, nous accompagnons les entreprises dans leurs projets de
//           formation continue, avec des programmes personnalisables selon les
//           objectifs et les compétences recherchées.
//         </p>
//       </div>
//       <div>
//         <h1>
//           POURQUOI <span>TRAVAILLER</span> AVEC NOUS ?
//         </h1>
//         <p>
//             - Accompagnement sur la démarche OPCO ou plan de développement des
//             compétences. <br /> <br />- Formation en intra ou inter selon vos
//             équipes, à taille humaine, et orientée résultat.
//         </p>
//       </div>
//     </section>
//   );
// };

// export default Entreprise;

import React from "react";
import certifIcon from "../../assets/img/aboutUs/content.png";
import surMesureIcon from "../../assets/img/aboutUs/mortarboard.png";
import deviseIcon from "../../assets/img/aboutUs/skill-development.png";

const Entreprise = () => {
  return (
    <section className="entreprise-section" id="entreprise">
      <div>
        <h1>
          FORMATIONS <span>SUR MESURE</span> POUR LES ENTREPRISES
        </h1>
        <p>
          Chez UP4MIND, nous accompagnons les entreprises dans leurs projets de
          formation continue, avec des programmes personnalisables selon les
          objectifs et les compétences recherchées.
        </p>
      </div>
      <div>
        <h1>
          POURQUOI <span>TRAVAILLER</span> AVEC NOUS ?
        </h1>
        <p>
          - Accompagnement personnalisé pour définir et piloter votre stratégie
          de formation. <br />
          <br />- Formations intra et inter-entreprises adaptées à vos équipes,
          alliant agilité et efficacité.
        </p>
      </div>
    </section>
  );
};

export default Entreprise;
